<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" :width="width" :height="height" viewBox="0 0 300.000000 300.000000" preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" :fill="iconColor" stroke="none">
        <path d="M1464 2780 c-11 -4 -33 -22 -47 -40 l-27 -32 0 -496 0 -497 -93 93 c-57 57 -105 96 -125 101 -89 26 -176 -59 -152 -147 7 -29 57 -84 223 -250 233 -233 247 -242 319 -208 19 9 125 108 236 219 169 170 201 208 207 240 10 50 -1 85 -35 117 -67 63 -129 45 -247 -72 l-82 -82 -3 490 c-3 461 -4 491 -22 517 -33 49 -97 69 -152 47z"/>
        <path d="M1322 1025 c-302 -55 -564 -223 -732 -470 -52 -77 -101 -169 -119 -228 -25 -76 32 -157 110 -157 70 0 93 20 150 131 94 183 224 315 394 399 138 68 217 85 390 84 134 0 159 -3 240 -28 249 -76 426 -228 548 -472 44 -88 74 -114 133 -114 60 0 113 46 121 107 5 35 -1 55 -35 125 -164 335 -461 560 -821 622 -112 19 -277 19 -379 1z"/>
      </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "IconInternalCredit",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
